module.exports = __webpack_public_path__ + "img/threads.fed43fac.svg";